import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from '../../shared/Constants';

@Injectable()
export class ClientBusinessNameService {

  constructor(private http: HttpClient) { }

  getAllBusiness(idClient) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/alter-clients', { headers: headers, params: { id_client: idClient } });
  }
}



// WEBPACK FOOTER //
// ./src/app/system/services/client-business-name.service.ts